<template lang="pug">
.v-acc-tabs.acc-tabs(v-if="data" :id="data?.id")
	.acc-tabs__title(v-if="data.title" :class="[data.title.class]") {{ data.title.text }}
	.acc-tabs__tags.tags(v-if="data.tabs")
		.tags__items
			.tags__item(v-for="tab in data.tabs" @click="handlerTabClick(tab)" :class="{'active': tab.active}") {{tab.title}}
	template(v-for="(tab, tabIndex) in data.tabs" :key="tabIndex")
		.acc-tabs__content(v-if="tab.items && tab.items.length" :class="{'acc-tabs__content--visible': tab.active}")
			template(v-if="isTablet")
				.acc-tabs__control(v-if="activeTab && activeTab.items && activeTab.items.length")
					.acc-tabs__control-item(v-for="(item, index) in activeTab.items"
							:class="{'active': activeTabItem && item.id === activeTabItem.id}"
							:key="index")
						button.acc-tabs__control-btn(type="button" @click="handlerTabItemClick(item)")
							| {{item.title}}
							v-svg-icon.acc-tabs__control-btn-icon(icon="dropdown-small")
						.acc-tabs__control-body-wrap(v-if="activeTabItem && activeTabItem.items && activeTabItem.items.length")
							.acc-tabs__control-body
								.acc-tabs__body-item
									v-acc(:items="activeTabItem.items")
			template(v-else)
				.acc-tabs__control(v-if="activeTab && activeTab.items && activeTab.items.length")
					.acc-tabs__control-item(v-for="(item, index) in activeTab.items"
							:class="{'active': activeTabItem && item.id === activeTabItem.id}"
							:key="index")
						button.acc-tabs__control-btn(type="button" @click="handlerTabItemClick(item)") {{item.title}}
				.acc-tabs__body(v-if="activeTabItem && activeTabItem.items && activeTabItem.items.length")
					v-acc(:items="activeTabItem.items")
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";
import {SwiperSlide} from 'swiper/vue';

export default {

	components: {
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			activeTab: null,
			activeTabItem: null,
			activeItem: null
		}
	},

	methods: {
		getNext(el, selector) {
			const nextEl = el.nextElementSibling;
			if (!selector || (nextEl && nextEl.matches(selector))) {
				return nextEl;
			}
			return null;
		},

		setHeight(el, val) {
			if (typeof val === 'function') val = val();
			if (typeof val === 'string') el.style.height = val;
			else el.style.height = val + 'px';
		},

		setHeights() {
			let $itemBodies = this.$el.querySelectorAll('.acc-tabs__control-body');
			if ($itemBodies && $itemBodies.length) {
				$itemBodies.forEach($bodyWrap => {
					$bodyWrap.setAttribute('data-height', $bodyWrap.getBoundingClientRect().height);
				});
			}
		},

		dataSet(data) {
			this.data = data;
			if (this.data.tabs && this.data.tabs.length) {
				this.activeTab = this.data.tabs.find(tab => tab.active);
				this.activeTabItem = this.activeTab.items[0];
				this.activeItem = this.activeTabItem.items[0];
			}
			this.$nextTick(() => {
				this.setHeights();
			});
		},

		handlerTabClick(tab) {
			this.data.tabs.forEach(tab => tab.active = false);
			tab.active = true;
			this.activeTab = tab;
			this.activeTabItem = this.activeTab.items[0];
			this.activeItem = this.activeTabItem.items[0];
		},

		handlerTabItemClick(activeTabItem) {
			this.activeTabItem = activeTabItem;
		}
	}
}

</script>